/* eslint-disable @typescript-eslint/no-unused-vars */
import { columnChooserId, ScopeLevel, treeViewButtonId, listViewButtonId } from './constant';

interface ToolbarWithSelectionProps {
  selectedItems: any[];
  permissions: any;
  i18n: any;
  serverContext: any;
  onBidChangeClick: Function;
}

function toolbarItemsWithSelection({
  selectedItems,
  permissions,
  i18n,
  serverContext,
  onBidChangeClick,
}: ToolbarWithSelectionProps) {
  // const isCurrentAccountInActive = serverContext.CurrentAccount.Status === 32; // 32 is InActive
  const isBidValueOption = true;
  const isBidBoostOption = false;

  const candidates: any[] = [
    ['expander', {
      type: 'expander',
    }],
    ['button-clear-selection', {
      type: 'button-clear-selection',
    }],
    ['divider', {
      id: 'product-groups-toolbar-divider',
      type: 'divider',
    }],
    ['button-chart-toggle', {
      id: 'button-chart-toggle',
      type: 'button',
    }],
  ];
  return new Map(candidates.filter(c => !!c));
}

interface ToolbarWithoutSelectionConfigProps {
  scopeLevel: ScopeLevel,
  i18n: any,
}

function toolbarItemsWithoutSelection({
  scopeLevel, i18n,
}: ToolbarWithoutSelectionConfigProps) {
  const candidates: any[] = [
    ['expander', {
      type: 'expander',
    }],
    [columnChooserId, {
      id: columnChooserId,
      type: 'dropdown',
    }],
    ['Expand table', {
      type: 'expand-table',
    }],
    scopeLevel === ScopeLevel.AssetGroup && [treeViewButtonId, {
      type: 'button',
      classes: ['view-switch-button', 'inactive'], // default inactive, update by callback
      iconLeftGlyphName: 'ba-BulletedTreeList',
      id: treeViewButtonId,
      ariaLabel: i18n.getString(_TL_('switch to hierarchy view')),
      attrs: {
        title: i18n.getString(_TL_('Hierarchy view')),
      },
    }],
    scopeLevel === ScopeLevel.AssetGroup && [listViewButtonId, {
      type: 'button',
      classes: ['view-switch-button', 'inactive'], // default inactive, update by callback
      iconLeftGlyphName: 'ba-BulletedList2',
      id: listViewButtonId,
      ariaLabel: i18n.getString(_TL_('switch to list view')),
      attrs: {
        title: i18n.getString(_TL_('List view')),
      },
    }],
  ];

  return new Map(candidates.filter(toolbarItem => !!toolbarItem));
}

interface ToolbarConfigProps {
  scopeLevel: ScopeLevel,
  i18n: any,
  selectedItems: any[];
  permissions: any;
  serverContext: any;
  onBidChangeClick: Function;
}

export function getGridToolbarConfig({
  scopeLevel, i18n, onBidChangeClick, permissions, selectedItems, serverContext,
}: ToolbarConfigProps) {
  const toolbarUnselectedConfig = toolbarItemsWithoutSelection({
    scopeLevel, i18n,
  });
  const toolbarSelectedConfig = toolbarItemsWithSelection({
    i18n,
    onBidChangeClick,
    permissions,
    selectedItems,
    serverContext,
  });
  return { toolbarSelectedConfig, toolbarUnselectedConfig };
}
